<template>
  <div>
    <b-card no-body>
      <b-card-body class="text-right">
        <b-button
          variant="primary"
          @click="openModal"
        >
          <FeatherIcon icon="PlusIcon" />
          Malzeme Ekle
        </b-button>
      </b-card-body>
      <b-table-simple v-if="dataList.length">
        <b-thead>
          <b-tr>
            <b-th>MALZEME</b-th>
            <b-th class="width-200">
              MİKTAR
            </b-th>
            <b-th class="width-200 text-center">
              <FeatherIcon
                icon="EditIcon"
                class="mx-1"
              />
              <FeatherIcon
                icon="Trash2Icon"
                class="mx-1"
              />
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="item in dataList"
            :key="item.id"
          >
            <b-td>
              <div class="font-weight-bold">
                {{ item.title }}
              </div>
              <div class="font-small-3 text-muted">
                {{ item.username }} tarafından {{ moment(item.created).format('llll') }} tarihinde eklenmiştir.
              </div>
            </b-td>
            <b-td>
              {{ item.quantity }} {{ item.unit }}
            </b-td>
            <b-td class="text-center">
              <b-button
                variant="flat-info"
                pill
                class="btn-icon mx-1"
                @click="editModal(item)"
              >
                <FeatherIcon icon="EditIcon" />
              </b-button>
              <b-button
                variant="flat-danger"
                pill
                class="btn-icon mx-1"
                @click="removeData(item.id)"
              >
                <FeatherIcon icon="Trash2Icon" />
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-card-body v-else>
        <b-alert
          show
          variant="danger"
        >
          <div class="alert-body text-center">
            <div>
              <FeatherIcon icon="InfoIcon" />
            </div>
            <div>
              Henüz hiç malzeme eklenmemiş, malzeme ekle butonu ile kullanılan malzemeleri tanımlayabilirsiniz.
            </div>
          </div>
        </b-alert>
      </b-card-body>
    </b-card>
    <material-modal :refresh-data-list="getDataList" />
  </div>
</template>
<script>
import {
  BCard, BCardBody, BButton, BTableSimple, BThead, BTr, BTh, BTd, BTbody, BAlert,
} from 'bootstrap-vue'
import MaterialModal from '@/views/Services/View/MaterialModal.vue'

export default {
  name: 'MaterialList',
  components: {
    BCard,
    BCardBody,
    BButton,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BAlert,
    MaterialModal,
  },
  computed: {
    dataList() {
      return this.$store.getters['serviceMaterials/dataList']
    },
    dataItem() {
      return this.$store.getters['serviceMaterials/dataItem']
    },
    modalData() {
      return this.$store.getters['serviceMaterials/modalData']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    openModal() {
      this.modalData.status = true
      this.$store.commit('serviceMaterials/RESET_DATA_ITEM')
    },
    editModal(data) {
      this.dataItem.id = data.id
      this.dataItem.title = data.title
      this.dataItem.quantity = data.quantity
      this.dataItem.id_units = data.id_units
      this.modalData.status = true
    },
    getDataList() {
      this.$store.dispatch('serviceMaterials/getDataList', {
        where: {
          'service_materials.id_services': this.$route.params.id,
        },
      })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('serviceMaterials/removeData', id)
            .then(response => {
              if (response.status) {
                this.getDataList()
              }
            })
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
